import { TabType } from '@aloft/toolkit-sui';

import { DepreciatedCostTabPanels } from './tabPanels/DepreciatedCostTabPanels.tsx';
import { MarketConditionsTabPanels } from './tabPanels/MarketConditionsTabPanels.tsx';
import { PriorSalesTabPanels } from './tabPanels/PriorSalesTabPanels.tsx';
import { SiteExtractionTabPanels } from './tabPanels/SiteExtractionTabPanels.tsx';
import { Tab, TabPanels } from './types.ts';

export const tabs: TabType<Tab>[] = [
  {
    label: 'Market Condition',
    value: 'market-condition',
  },
  {
    label: 'Prior Sales',
    value: 'prior-sales',
  },
  {
    label: 'Site Extraction',
    value: 'site-extraction',
  },
  {
    label: 'Depreciated Cost',
    value: 'depreciated-cost',
  },
];

export const tabPanelsMap: Record<Tab, TabPanels> = {
  'market-condition': {
    left: <MarketConditionsTabPanels.LeftPanel />,
    right: <MarketConditionsTabPanels.RightPanel />,
  },
  'prior-sales': {
    left: <PriorSalesTabPanels.LeftPanel />,
    right: <PriorSalesTabPanels.RightPanel />,
  },
  'site-extraction': {
    left: <SiteExtractionTabPanels.LeftPanel />,
    right: <SiteExtractionTabPanels.RightPanel />,
  },
  'depreciated-cost': {
    left: <DepreciatedCostTabPanels.LeftPanel />,
    right: <DepreciatedCostTabPanels.RightPanel />,
  },
};
